module.exports = "./dist/assets/images/icons/973cd5e85cef5713acc6073fb6c80a0f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ticketsgit.png
// module id = ./assets/images/icons/ticketsgit.png
// module chunks = 0